// extracted by mini-css-extract-plugin
export var container = "styles-module__container___AotXu";
export var divider = "styles-module__divider___2y8Ln";
export var header = "styles-module__header___ezIhH";
export var next = "styles-module__next___apvOx";
export var previous = "styles-module__previous___D0xL8";
export var riverClass = "styles-module__riverClass___jZOIL";
export var riverContainer = "styles-module__riverContainer___J0gB6";
export var storeLink = "styles-module__storeLink___ywXnd";
export var title = "styles-module__title___V5v5O";